const bgColors = {
  // Red
  bgRed50: { backgroundColor: "#fef2f2" },
  bgRed100: { backgroundColor: "#fee2e2" },
  bgRed200: { backgroundColor: "#fecaca" },
  bgRed300: { backgroundColor: "#fca5a5" },
  bgRed400: { backgroundColor: "#f87171" },
  bgRed500: { backgroundColor: "#ef4444" },
  bgRed600: { backgroundColor: "#dc2626" },
  bgRed700: { backgroundColor: "#b91c1c" },
  bgRed800: { backgroundColor: "#991b1b" },
  bgRed900: { backgroundColor: "#7f1d1d" },
  bgRed950: { backgroundColor: "#450a0a" },
  // Slate
  bgSlate50: { backgroundColor: "#f8fafc" },
  bgSlate100: { backgroundColor: "#f1f5f9" },
  bgSlate200: { backgroundColor: "#e2e8f0" },
  bgSlate300: { backgroundColor: "#cbd5e1" },
  bgSlate400: { backgroundColor: "#94a3b8" },
  bgSlate500: { backgroundColor: "#64748b" },
  bgSlate600: { backgroundColor: "#475569" },
  bgSlate700: { backgroundColor: "#334155" },
  bgSlate800: { backgroundColor: "#1e293b" },
  bgSlate900: { backgroundColor: "#0f172a" },
  bgSlate950: { backgroundColor: "#020617" },
  // Gray
  bgGray50: { backgroundColor: "#f9fafb" },
  bgGray100: { backgroundColor: "#f3f4f6" },
  bgGray200: { backgroundColor: "#e5e7eb" },
  bgGray300: { backgroundColor: "#d1d5db" },
  bgGray400: { backgroundColor: "#9ca3af" },
  bgGray500: { backgroundColor: "#6b7280" },
  bgGray600: { backgroundColor: "#4b5563" },
  bgGray700: { backgroundColor: "#374151" },
  bgGray800: { backgroundColor: "#1f2937" },
  bgGray900: { backgroundColor: "#111827" },
  bgGray950: { backgroundColor: "#030712" },
  // Green
  bgGreen50: { backgroundColor: "#f0fdf4" },
  bgGreen100: { backgroundColor: "#dcfce7" },
  bgGreen200: { backgroundColor: "#bbf7d0" },
  bgGreen300: { backgroundColor: "#86efac" },
  bgGreen400: { backgroundColor: "#4ade80" },
  bgGreen500: { backgroundColor: "#22c55e" },
  bgGreen600: { backgroundColor: "#16a34a" },
  bgGreen700: { backgroundColor: "#15803d" },
  bgGreen800: { backgroundColor: "#166534" },
  bgGreen900: { backgroundColor: "#14532d" },
  bgGreen950: { backgroundColor: "#052e16" },
  // Blue
  bgBlue50: { backgroundColor: "#eff6ff" },
  bgBlue100: { backgroundColor: "#dbeafe" },
  bgBlue200: { backgroundColor: "#bfdbfe" },
  bgBlue300: { backgroundColor: "#93c5fd" },
  bgBlue400: { backgroundColor: "#60a5fa" },
  bgBlue500: { backgroundColor: "#3b82f6" },
  bgBlue600: { backgroundColor: "#2563eb" },
  bgBlue700: { backgroundColor: "#1d4ed8" },
  bgBlue800: { backgroundColor: "#1e40af" },
  bgBlue900: { backgroundColor: "#1e3a8a" },
  bgBlue950: { backgroundColor: "#172554" },
  // Indigo
  bgIndigo50: { backgroundColor: "#eef2ff" },
  bgIndigo100: { backgroundColor: "#e0e7ff" },
  bgIndigo200: { backgroundColor: "#c7d2fe" },
  bgIndigo300: { backgroundColor: "#a5b4fc" },
  bgIndigo400: { backgroundColor: "#818cf8" },
  bgIndigo500: { backgroundColor: "#6366f1" },
  bgIndigo600: { backgroundColor: "#4f46e5" },
  bgIndigo700: { backgroundColor: "#4338ca" },
  bgIndigo800: { backgroundColor: "#3730a3" },
  bgIndigo900: { backgroundColor: "#312e81" },
  bgIndigo950: { backgroundColor: "#1e1b4b" },
};

const styles = {
  ...bgColors,
  card: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "100%",
    minWidth: "0",
    boxSizing: "border-box",
    borderRadius: "8px",
    padding: "12px",
    marginTop: "0",
    marginBottom: "0",
    boxShadow: "0 0 2px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)",
  },
  text: {
    // color: "var(--colorNeutralForeground1)",
    // color: "white",
  },
  fontWeight100: {
    fontWeight: 100,
  },
  fontWeight200: {
    fontWeight: 200,
  },
  fontWeight300: {
    fontWeight: 300,
  },
  fontWeight400: {
    fontWeight: 400,
  },
  fontWeight500: {
    fontWeight: 500,
  },
  fontWeight600: {
    fontWeight: 600,
  },
  fontWeight700: {
    fontWeight: 700,
  },
  fontWeight800: {
    fontWeight: 800,
  },
  fontWeight900: {
    fontWeight: 900,
  },
  field: {
    fontWeight: 400,
    minWidth: "100%",
  },
  button: {
    fontWeight: 400,
  },
  label: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
  },
  input: {
    fontWeight: 400,
  },
  checkbox: {
    fontWeight: 400,
  },
  radio: {
    fontWeight: 400,
  },
  divider: {
    marginTop: "4px",
    marginBottom: "4px",
  },
  menuItem: {
    height: "18px",
    display: "flex",
    alignItems: "center",
  },
};

export default styles;
